export enum PeriodEnum {
  day = 'DAY',
  week = 'WEEK',
  month = 'MONTH',
  twoMonth = 'TWOMONTH',
  year = 'YEAR',
  max = 'MAX',
}

export enum FundsPeriodEnum {
  MONTH = 'MONTH',
  THREEMONTH = 'THREEMONTH',
  SIXMONTH = 'SIXMONTH',
  YEAR = 'YEAR',
  FIVEYEAR = 'FIVEYEAR',
}
